// @ts-nocheck
import { Column } from 'react-table'
import { LogCeldaAccion } from './LogCeldaAccion'
import { LogCeldaDescripcion } from './LogCeldaDescripcion'
import { LogCeldaNombreTabla } from './LogCeldaNombreTabla'
import { UserCustomHeader } from './UserCustomHeader'
import { Log } from '../../core/_models'
import { LogCeldaFecha } from './LogCeldaFecha'

const logsColumns: ReadonlyArray<Column<Log>> = [
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Acción' className='max-w-100px' />,
    id: 'accion',
    Cell: ({ ...props }) => <LogCeldaAccion accion={props.data[props.row.index].accion} />,
  },
  {
    Header: (props) => (<UserCustomHeader tableProps={props} title='Descripción' className='max-w-100px' />),
    id: 'descripcion',
    Cell: ({ ...props }) => <LogCeldaDescripcion descripcion={props.data[props.row.index].descripcion} />,
  },
  {
    Header: (props) => (<UserCustomHeader tableProps={props} title='Módulos' className='max-w-100px' />),
    id: 'modulo',
    Cell: ({ ...props }) => <LogCeldaNombreTabla nombreTabla={props.data[props.row.index].nombreTabla} />,
  },
  {
    Header: (props) => (<UserCustomHeader tableProps={props} title='Fecha' className='max-w-100px text-end' />),
    id: 'fecha',
    Cell: ({ ...props }) => <LogCeldaFecha fecha={props.data[props.row.index].fecha} />,
  },
  // {
  //   Header: (props) => (<UserCustomHeader tableProps={props} title='Acciones' className='max-w-100px' />),
  //   id: 'acciones',
  //   Cell: ({ ...props }) => <UserActionsCell id={props.data[props.row.index].id} />,
  // },
]

export { logsColumns }
